// extracted by mini-css-extract-plugin
export default {"formFieldSearch":"FormSelect_formFieldSearch__WnXT-","loading":"FormSelect_loading__tO0e8","rotation":"FormSelect_rotation__oUGe7"};